import { Component, Vue } from 'vue-property-decorator';
import WithRender from './FlexiPay.html';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { PriceList, ProductRow } from '@/types/ProductTypes';
import config from '@/settings/config';
import VuePhoneNumberInput from "vue-phone-number-input";

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD')
    }
  },
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters("originatorStore", {originator:"getOriginator",currency:"getWalletCurrency"}),
  }
})

export default class FlexiPay extends Vue {
  priceList: PriceList = {} as PriceList;
  isLoading = false;

  form = {
    description:'',
    amount: '',
    receiverNumberwithCountryCode:'',
    senderNumberWithCountryCode:'',
    valideSenderNumberMessage:'',
    payerCountryCode:'',
    payerNumber:'',
    senderNumber:'',
    valideReceiverNumberMessage:'',
    receiverNumber:''
  }

  async getProduct():Promise<void>
  {
    const parameters ={
      description:this.form.description,
      amount:this.form.amount
     }

     let dto = {
       portiFolio:"flexiPay",
       originator:'za',
       parameters: JSON.stringify(parameters)
     }

     this.isLoading = true;
     
     try{
       if(!this.validate())
       return;
     const result = await this.$store.dispatch("product/GetPortiFolioOnlyProducts", dto)
      this.priceList = result as PriceList;
       if(this.priceList.productList.length>0)
          await this.CheckOutProduct();
    }
    catch (error)
    {
     this.ErrorNotifications(error);
    }
    finally
    {
      this.isLoading = false;
    }
  }

  ValidateSenderNumber(payload: any) {
    this.form.senderNumberWithCountryCode = payload.countryCallingCode + payload.nationalNumber;
    this.form.payerNumber = payload.nationalNumber
    this.form.payerCountryCode = payload.countryCode;
    if (payload.isValid) {
      this.form.valideSenderNumberMessage = '';
    } else {
      this.form.valideSenderNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  ValidateReceiverNumber(payload: any) {
    this.form.receiverNumberwithCountryCode = payload.countryCallingCode + payload.nationalNumber;
    this.form.receiverNumber = payload.countryCode;
    if (payload.isValid) {
      this.form.valideReceiverNumberMessage = '';
    } else {
      this.form.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
    }
  }

  async CheckOutProduct() {
    const checkOut = {
      key: this.priceList.key,
      salesCurrencyAmount: this.priceList.productList[0].salesCurrencyAmount,
      totalAmount: this.priceList.productList[0].totalAmount,
      description: this.priceList.productList[0].description,
      senderNumber: this.form.senderNumberWithCountryCode,
      receiveNumber: this.form.receiverNumberwithCountryCode,
      portiFolio: "flexiPay",
      itemName: this.priceList.productList[0].description,
      accountNo: this.priceList.productList[0].extra1,
      isoCountry: "za",
      totalLessSalesAmountFee:this.priceList.productList[0].totalLessSalesAmountFee
    }
    await this.$store.dispatch("shoppingCart/addToCart", checkOut);
    await this.$store.dispatch("shoppingCart/addPayerCountryCode", this.form.payerCountryCode);
    await this.$store.dispatch("shoppingCart/addPayerNumber", this.form.payerNumber);
    this.$router.push("FlexiPayCheckOut");
  }

  Notify(message: any) {
    this.$bvToast.toast(message, {
      title: "Notification",
      variant: "danger",
      autoHideDelay: 5000,
    });
  }

  validate() {
    if (this.form.valideReceiverNumberMessage != '' || 
        this.form.valideSenderNumberMessage !='' ||
        this.form.receiverNumberwithCountryCode==''||
        this.form.senderNumberWithCountryCode ==''|| 
        this.form.description =='' ||
        this.form.amount ==''
    ) {
      this.Notify("Please make sure all the information is captured before proceeding");
      return false;
    }
    return true;
  }

  ErrorNotifications(obj:any) {
    let errorNotification = "";
    for (let prop in obj) {
      errorNotification += obj[prop].description + "\n";
    }
    this.Notify(errorNotification);
  }
}
